import React, { useEffect } from 'react'

import { Box, WizardStep } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import { WizardData } from '../../types'
import PreviewHeader from './Header'
import components, { TaskComponent } from './components'

interface Props {
  data: WizardData
  onDataChanged: (newData: WizardData) => void
}

const Preview = ({ data, onDataChanged }: Props) => {
  const Component = components[
    data.taskType as TaskConfigurationTypes & DataCollectionCategories
  ] as TaskComponent

  useEffect(() => {
    onDataChanged({ ...data, currentStepIndex: 2 })
  }, [])

  return (
    <>
      <PreviewHeader />

      <Box gap="s16" paddingY="s24">
        <Box
          padding="s24"
          gap="s16"
          border={{ all: { width: 's1', style: 'solid', color: 'grey200' } }}
          borderRadius={{ all: 'abs016' }}
        >
          <Component />
        </Box>
      </Box>
    </>
  )
}

export const previewStep = (): WizardStep<WizardData> => ({
  title: i18n.t('processes.process_settings.wizard.tasks.preview.title'),
  nextText: i18n.t('processes.process_settings.wizard.tasks.button.create_task'),
  render: (props) => <Preview data={props.data} onDataChanged={props.onDataChanged} />,
  isCompleted: (data) => data.currentStepIndex === 2,
})
